export const getRequisitionState = ({
  currUser,
  requisitions,
  _showLegacyFlowDynamically = false,
  _hasExistingRequisitions,
  switched_to_new_req = false,
}) => {
  // Calculate derived values
  const userHasReqEnabled = currUser?.requisition?.enabled;
  const hasExistingRequisitionsWithRole = requisitions?.some((req) =>
    Boolean(req?.role_name)
  );

  // Logic for different scenarios:
  // 1. User has req enabled + No existing requisitions → AssociateReq flow
  // 2. User has req enabled + Has existing requisitions with role_name → AssociateReq flow
  // 3. User has req enabled + Has existing requisitions but NO role_name → Legacy flow
  // 4. User has NO req enabled + Has existing requisitions with role_name → AssociateReq (read-only)
  // 5. User has NO req enabled + No existing requisitions → Legacy flow

  const shouldUseAssociateReq =
    userHasReqEnabled && (switched_to_new_req || requisitions.length === 0);

  const shouldUseLegacyFlow =
    (userHasReqEnabled &&
      !switched_to_new_req &&
      !hasExistingRequisitionsWithRole &&
      requisitions.length > 0) ||
    (!userHasReqEnabled && !switched_to_new_req);

  return {
    shouldUseAssociateReq,
    shouldUseLegacyFlow,
    userHasReqEnabled,
    hasExistingRequisitionsWithRole,
  };
};

export const REJECTED_OFFER_STATUSES = ['rejected', 'rejected_by_candidate'];

export const getRequisitionStateOffer = ({
  currUser,
  requisitions,
  showLegacyFlowDynamically = false,
  showInputField = false,
  offerStatus = '',
}) => {
  const userHasReqEnabled = currUser?.requisition?.enabled;
  const hasExistingRequisitionsWithRole = requisitions?.some((req) =>
    Boolean(req?.role_name)
  );

  // For rejected offers with no linked req, req-enabled users should see the new UI
  const forceAssociateReq =
    !showLegacyFlowDynamically &&
    userHasReqEnabled &&
    REJECTED_OFFER_STATUSES.includes(offerStatus) &&
    showInputField;

  const shouldUseAssociateReq =
    !showLegacyFlowDynamically &&
    (!showInputField || hasExistingRequisitionsWithRole || forceAssociateReq);

  const shouldUseLegacyFlow =
    showLegacyFlowDynamically ||
    (!forceAssociateReq && showInputField && !hasExistingRequisitionsWithRole);

  return {
    shouldUseAssociateReq,
    shouldUseLegacyFlow,
    userHasReqEnabled,
    hasExistingRequisitionsWithRole,
  };
};
